import { CasesContainer } from "../components/Cases/CasesContainer";
import { ExpertPortalAuthenticationTemplate } from "../components/AuthenticationTemplate/AuthenticationTemplate";
import { useGetAccessToken } from "../hooks/useGetAccessToken";
import { useGetCases } from "../hooks/cases/useGetCases";

export const CasesPage = () => {
  const accessToken = useGetAccessToken();
  const cases = useGetCases(accessToken);
  return (
    <ExpertPortalAuthenticationTemplate>
      {cases && <CasesContainer cases={cases} />}
    </ExpertPortalAuthenticationTemplate>
  );
};
